import { Divider, ListItem, ListItemButton, ListItemText } from "@mui/material";
import UserMenuItem from "../UserMenuItem/UserMenuItem";
import EditIcon from "@mui/icons-material/Edit";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setIsInEditMode } from "../../../redux/reducers/appReducer";
import { Close } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import MicIcon from "@mui/icons-material/Mic";
import ProtectedComponent from "../../atoms/ProtectedComponent/ProtectedComponent";
import AssistantIcon from "@mui/icons-material/Assistant";

interface SidebarBottomProps {
  isAiAssistantOpen: boolean;
  isDictationOpen: boolean;
  onAiAssistantOpen: () => void;
  onSettingsOpen: () => void;
  onEditToggle: () => void;
  onDictationOpen: () => void;
}

const SidebarBottom = (props: SidebarBottomProps) => {
  const {
    isDictationOpen,
    isAiAssistantOpen,
    onSettingsOpen,
    onEditToggle,
    onDictationOpen,
    onAiAssistantOpen,
  } = props;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const user = useSelector((state: any) => state.settings.user);
  const isCurrentlyInEditMode = useSelector(
    (state: any) => state.app.isInEditMode,
  );
  const canUserEdit =
    user?.subscription === "pro" ||
    user?.subscription === "premium" ||
    user?.subscription === "free";

  // const canUserUseAiAssistant =
  //   user?.subscription === "pro" || user?.subscription === "free";
  const canUserUseAiAssistant = true;

  const aiAssistantClassName = classNames("dui-sidebar-item", {
    "dui-sidebar-item-active": isAiAssistantOpen,
  });

  const editClassName = classNames("dui-sidebar-item", {
    "dui-sidebar-item-active": isCurrentlyInEditMode,
  });

  const dictationClassName = classNames("dui-sidebar-item", {
    "dui-sidebar-item-active": isDictationOpen,
  });

  const handleProfileOpen = () => {
    if (isDictationOpen) {
      handleDictationClick();
    }
    onSettingsOpen();
  };

  const handleEditModeToggle = () => {
    if (isDictationOpen) {
      onDictationOpen();
    }
    if (canUserEdit) {
      dispatch(setIsInEditMode(!isCurrentlyInEditMode));
      onEditToggle();
    }
  };

  const handleDictationClick = () => {
    if (isCurrentlyInEditMode) {
      dispatch(setIsInEditMode(false));
      onEditToggle();
    }
    onDictationOpen();
  };

  return (
    <div className="dui-sidebar-bottom">
      <Divider className="dui-sidebar-item-divider" />
      <ListItem key={"edit"} className={editClassName} disablePadding>
        <ListItemButton
          className="dui-sidebar-item-button"
          onClick={handleEditModeToggle}
          disabled={!canUserEdit}
        >
          {isCurrentlyInEditMode ? <Close /> : <EditIcon />}
          <ListItemText primary={t("editMode")} />
        </ListItemButton>
      </ListItem>
      <ProtectedComponent role="admin">
        <ListItem
          key={"aiAssistant"}
          className={aiAssistantClassName}
          disablePadding
        >
          <ListItemButton
            className="dui-sidebar-item-button"
            onClick={onAiAssistantOpen}
            disabled={!canUserUseAiAssistant}
          >
            <AssistantIcon />
            <ListItemText primary={t("aiAssistant")} />
          </ListItemButton>
        </ListItem>
      </ProtectedComponent>
      <ProtectedComponent role="admin">
        <ListItem
          key={"dictation"}
          className={dictationClassName}
          disablePadding
        >
          <ListItemButton
            className="dui-sidebar-item-button"
            onClick={handleDictationClick}
          >
            <MicIcon />
            <ListItemText primary={t("dictation")} />
          </ListItemButton>
        </ListItem>
      </ProtectedComponent>
      <Divider className="dui-sidebar-item-divider" />
      <UserMenuItem onSettingsOpen={handleProfileOpen} name={user?.name} />
    </div>
  );
};

export default SidebarBottom;
